import React from "react";
import {
  FormDataConsumer,
  DateInput,
  required
} from "react-admin";

const QuoteReleaseDateInput = ({ formClassName }) => (
  <FormDataConsumer>
    {({ formData }) => {
      const isFinalised = Number(formData?.statusId) === 234;

      return (
        <DateInput
          source="quoteReleaseDate"
          label="Quote Release Date"
          validate={isFinalised ? [required()] : []}
          fullWidth
          formClassName={formClassName}
          helperText={
            isFinalised ? "Required when status is Quote Released" : undefined
          }
        />
      );
    }}
  </FormDataConsumer>
);

export default QuoteReleaseDateInput;
